var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95833 7.79165C3.95833 7.79165 3.95922 5.83662 3.95833 4.95832C3.95745 4.08002 4.28295 3.23273 4.87164 2.58092C5.46033 1.92911 6.27021 1.51929 7.14407 1.43102C8.01792 1.34276 8.8934 1.58234 9.60054 2.10325M2.54167 7.79165H12.4583C13.2407 7.79165 13.875 8.42592 13.875 9.20832V14.1667C13.875 14.9491 13.2407 15.5833 12.4583 15.5833H2.54167C1.75926 15.5833 1.125 14.9491 1.125 14.1667V9.20832C1.125 8.42592 1.75926 7.79165 2.54167 7.79165Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocak);
export default __webpack_public_path__ + "static/media/unlocak.516a6adec607649965d8a978ea9c926c.svg";
export { ForwardRef as ReactComponent };